import { distinct } from "src/common/utilities";

export class CssClassListExtractor{
    private static classList:string[];
    public static GetClassList():string[]{
        if(CssClassListExtractor.classList==null){
            const regex = /\.[A-Za-z0-9-]*/gm;
            let result = [];
            for(let i=0;i<document.styleSheets.length;i++){
                try{
                    if(document.styleSheets[i].href && document.styleSheets[i].href.search('app.css')>-1){
                        for(let j=0;j<document.styleSheets[i].cssRules.length;j++){
                            let rule = document.styleSheets[i].cssRules[j];
                            if(rule instanceof CSSStyleRule){
                                let str = rule.selectorText;
                                let m;
                                while ((m = regex.exec(str)) !== null) {
                                    // This is necessary to avoid infinite loops with zero-width matches
                                    if (m.index === regex.lastIndex) {
                                        regex.lastIndex++;
                                    }
                                    
                                    // The result can be accessed through the `m`-variable.
                                    m.forEach((match, groupIndex) => {
                                        result.push(match);
                                    });
                                }
                            }
                        }
                    }
                }
                catch{
                    alert('RUN FROM CHROME-DEV. Find related info in Console.');
                    console.log('Create chrome shortcut. then update the target field with the following config')
                    console.log('"C:\\Program Files\\Google\\Chrome\\Application\\chrome.exe" --disable-web-security --user-data-dir="C:/ChromeDevSession"')
                    return [];
                }
            }
            result = distinct(result);
            result = result.map(x=>x.substring(1));
            CssClassListExtractor.classList = result;
        }
        return CssClassListExtractor.classList;
    }
}